import { render, staticRenderFns } from "./PersonalDetailsForm.vue?vue&type=template&id=844d217c"
import script from "./PersonalDetailsForm.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./PersonalDetailsForm.vue?vue&type=style&index=0&id=844d217c&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('844d217c')) {
      api.createRecord('844d217c', component.options)
    } else {
      api.reload('844d217c', component.options)
    }
    module.hot.accept("./PersonalDetailsForm.vue?vue&type=template&id=844d217c", function () {
      api.rerender('844d217c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/AccountSetup/PersonalDetailsForm.vue"
export default component.exports